import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TableRow = styled.tr`
  text-align: center;
  &:nth-child(odd) {
    border: 1px solid ${colors.borderGray};
    border-color: #fbfcfc;
    background-color: rgb(240 240 241);
  }
  &:nth-child(even) {
    border: 1px solid ${colors.borderGray};
    border-color: #fbfcfc;
    background-color: ${colors.white};
  }

  ${(props) =>
    props.hasHoverEffect &&
    css`
      :hover {
        box-shadow: 3px 1px 3px 1px grey;
        transform: scaleX(1);
      }
    `}

  ${(props) =>
    props.isSelectedRow &&
    css`
      &:hover {
        color: ${colors.fsDarkBlue} !important;
        cursor: pointer;
      }
    `}
  ${(props) =>
    props.isHeading &&
    css`
      background-color: ${colors.white} !important;
      :hover {
        box-shadow: none;
        transform: none;
      }
    `}

    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Table = styled.table`
  font-weight: 400 !important;
  font-size: 14px;
  border: 2px solid ${colors.borderGray};
  background: white;
  margin: ${(props) => (props.margin ? props.margin : '0px')};
  width: 100%;
  ${(props) =>
    props.noBorder &&
    css`
      border: none;
    `}
`;

export const TableHeading = styled.th`
  line-height: 40px;
  ${(props) =>
    props.hideOnSmallDevice &&
    css`
      @media (max-width: 736px) {
        display: none;
      }
    `}

  ${(props) =>
    props.hideOnMobileDevice &&
    css`
      @media (max-width: 545px) {
        display: none;
      }
    `}

    ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `}
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TableHead = styled.thead``;

export const TableData = styled.td`
  border: 1px solid ${colors.borderGray};
  padding: ${({ noPadding }) => !noPadding && '0.75rem'};

  img {
    @media (min-width: 1366px) {
      max-width: 60%;
    }
  }

  ${(props) =>
    props.hideOnSmallDevice &&
    css`
      @media (max-width: 736px) {
        display: none;
      }
    `}

  ${(props) =>
    props.hideOnMobileDevice &&
    css`
      @media (max-width: 545px) {
        display: none;
      }
    `}

  ${(props) =>
    props.alignLeft &&
    css`
      text-align: left;
    `}

    ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `}

    ${(props) =>
    props.isFeedbackRow &&
    css`
      overflow-wrap: break-word;
      max-width: 200px;
    `}

    ${(props) =>
    props.noBorder &&
    css`
      border: none;
    `}
`;

export const TableDataLink = styled.a`
  padding: 0.75rem;
  display: block;
  color: inherit;

  &:link {
    text-decoration: none;
    color: inherit;
  }
  &:visited {
    text-decoration: none;
    color: inherit;
  }
  &:hover {
    text-decoration: none;
    color: inherit;
  }
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;

export const TableBody = styled.tbody`
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
`;

export const SortArrowImage = styled.img`
  height: 10px;
  width: 10px;
  margin-left: 5px;
  cursor: pointer;
`;

export const RankListContainer = styled.div`
  width: 100%;
`;
